import {
  VStack,
  Stack,
  Text,
  useBreakpointValue,
  Spinner,
  Center,
  Box,
} from "@chakra-ui/react";
import { KYDSubscription } from "@common/interfaces/KYDBilling";
import { PlanCard } from "./PlanCard";
import {
  DisplaySubscription,
  DisplaySubscriptionItem,
} from "@common/interfaces/KYDBilling";

interface PlansSectionProps {
  subscriptions: DisplaySubscription[];
  isLoading?: boolean;
}

export const PlansSection: React.FC<PlansSectionProps> = ({
  subscriptions,
  isLoading = false,
}) => {
  // Show loading spinner when initially loading
  if (isLoading) {
    return (
      <VStack w="100%" spacing={6}>
        <Stack w="100%" spacing={{ base: "8", lg: "6" }}>
          {/* Header */}
          <Stack
            spacing="4"
            w="full"
            direction={{ base: "column", lg: "row" }}
            justify="space-between"
            align={{ base: "start", lg: "center" }}
          >
            <Stack spacing="1">
              <Text fontSize="lg" fontWeight={"medium"}>
                Your Plans
              </Text>
            </Stack>
          </Stack>

          {/* Loading State */}
          <Box
            bg="gray.50"
            p={3}
            borderRadius="lg"
            border="1px solid"
            borderColor="gray.200"
            shadow="sm"
            w="full"
          >
            <Center py={8} w="full">
              <Stack spacing={4} align="center" w="full">
                <Spinner size="lg" color="blue.500" />
                <Text fontSize="sm" color="gray.500">
                  Loading plans...
                </Text>
              </Stack>
            </Center>
          </Box>
        </Stack>
      </VStack>
    );
  }

  // Flatten all plans from all subscriptions
  const allPlans: Array<{
    subscription: KYDSubscription;
    item: DisplaySubscriptionItem;
  }> = [];

  subscriptions.forEach((subscription) => {
    subscription.items.forEach((item) => {
      allPlans.push({ subscription, item });
    });
  });

  return (
    <VStack w="100%" spacing={6}>
      <Stack w="100%" spacing={{ base: "8", lg: "6" }}>
        {/* Header */}
        <Stack
          spacing="4"
          direction={{ base: "column", lg: "row" }}
          justify="space-between"
          align={{ base: "start", lg: "center" }}
        >
          <Stack spacing="1">
            <Text fontSize="lg" fontWeight={"medium"}>
              Your Plans
            </Text>
          </Stack>
        </Stack>

        {allPlans.length === 0 ? (
          <Box
            bg="white"
            p={3}
            borderRadius="lg"
            border="1px solid"
            borderColor="gray.200"
            shadow="sm"
            w="full"
          >
            <Center py={8}>
              <Text fontSize="sm" color="gray.500">
                No plans found
              </Text>
            </Center>
          </Box>
        ) : null}
        {/* Plans */}
        <Stack w="full" spacing={4}>
          {allPlans.map(({ subscription, item }, index) => (
            <PlanCard
              key={`${subscription.id}-${item.product_id}-${index}`}
              subscription={subscription}
              item={item}
            />
          ))}
        </Stack>
      </Stack>
    </VStack>
  );
};
